"use client";

import { useEffect, useState } from 'react';
import posthog from 'posthog-js';
import { fireEcommerceFromApp } from '@/lib/ga';
import { fireEcommerceFromApp as fireMetaPixelFromApp } from '@/lib/meta-pixel';

export function usePostHog() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Check if PostHog is initialized
    if (typeof window !== 'undefined' && posthog.__loaded) {
      setIsLoaded(true);
    }
  }, []);

  const track = (eventName: string, properties?: Record<string, any>) => {
    if (typeof window !== 'undefined' && posthog.__loaded) {
      posthog.capture(eventName, properties);
    }
    // Mirror key events to GA4 ecommerce (prod only, safe no-op otherwise)
    try { fireEcommerceFromApp(eventName, properties || {}) } catch {}
    // Mirror key events to Meta Pixel (prod only, safe no-op otherwise)
    try { fireMetaPixelFromApp(eventName, properties || {}) } catch {}
  };

  const identify = (userId: string, userProperties?: Record<string, any>) => {
    if (typeof window !== 'undefined' && posthog.__loaded) {
      posthog.identify(userId, userProperties);
    }
  };

  const alias = (alias: string) => {
    if (typeof window !== 'undefined' && posthog.__loaded) {
      posthog.alias(alias);
    }
  };

  const reset = () => {
    if (typeof window !== 'undefined' && posthog.__loaded) {
      posthog.reset();
    }
  };

  return {
    posthog: typeof window !== 'undefined' ? posthog : null,
    track,
    identify,
    alias,
    reset,
    isLoaded
  };
}
